
import { Registration } from '@/api/dtos/Registration.schema'
import { User } from '@/api/dtos/User.schema'
import CancelButton from '@/components/buttons/CancelButton.vue'
import EditButton from '@/components/buttons/EditButton.vue'
import { Component, Vue, Watch } from 'vue-property-decorator'
import * as authApi from '@/api/auth'
import Vuetify from 'vuetify/lib'
import { UsersModule } from '@/store/modules/UsersModule'

@Component({
  components: {
    EditButton,
    CancelButton
  }
})
export default class RegistrationView extends Vue {
  token: string | (string | null)[] = this.$route.params.token
  currentStep = 1
  form1Valid = false
  form2Valid = false
  form3Valid = false
  showPassword1 = false
  showPassword2 = false
  registrationLoading = false
  showSuccess = false
  showError = false

  registrationData: Registration = {
    firstName: '',
    lastName: '',
    phone: null,
    landlinePhone: null,
    password: ''
  }

  get localUser (): User | null {
    return UsersModule.localUser
  }

  @Watch('registrationData.phone')
  onPhoneChanged (data: string): void {
    if (data === '') this.registrationData.phone = null
  }

  @Watch('registrationData.landlinePhone')
  onLandlineChanged (data: string): void {
    if (data === '') this.registrationData.landlinePhone = null
  }

  async onRegistrationSubmit (): Promise<void> {
    this.registrationLoading = true
    try {
      await authApi.completeRegistration(this.token.toString(), this.registrationData)
      this.showSuccess = true
    } catch {
      this.showError = true
    }
    this.registrationLoading = false
    this.$vuetify.goTo('#scrollTarget')
  }
}
